import {
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  SIGNUP_START,
  SIGNUP_SUCCESS,
  SIGNUP_ERROR,
} from "./constants";
import {
  loginWithPassword,
  _register,
  _forgetPassword,
  _signup,
} from "./services";
import { errorParser } from "../../services/apiErrorParser";

/* Login actions */
export function loginSetLoading(loading) {
  return {
    type: LOGIN_LOADING,
    payload: loading,
  };
}

export function loginSetToken(token) {
  return {
    type: LOGIN_SUCCESS,
    payload: token,
  };
}

export function loginSetError(error) {
  return {
    type: LOGIN_ERROR,
    payload: error.message,
  };
}

export const checkLogin = (formData) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(loginSetLoading(true));
    loginWithPassword(formData)
      .then(async (res) => {
        // console.log(res)
        await dispatch(loginSetToken(res.token));
        resolve(res);
      })
      .catch((err) => {
        const parsedError = errorParser.parseError(err);
        dispatch(loginSetError(parsedError));
        reject(err);
      })
      .finally(() => {
        dispatch(loginSetLoading(false));
      });
  });
};
export const register = (formData) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(loginSetLoading(true));
    _register(formData)
      .then(async (res) => {
        resolve(res);
      })
      .catch((err) => {
        const parsedError = errorParser.parseError(err);
        dispatch(loginSetError(parsedError));
        reject(err);
      })
      .finally(() => {
        dispatch(loginSetLoading(false));
      });
  });
};
export const forgetPassword = (formData) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(loginSetLoading(true));
    _forgetPassword(formData)
      .then(async (res) => {
        resolve(res);
      })
      .catch((err) => {
        const parsedError = errorParser.parseError(err);
        dispatch(loginSetError(parsedError));
        reject(err);
      })
      .finally(() => {
        dispatch(loginSetLoading(false));
      });
  });
};
/**
 * new signup
 */
const signUpStart = (loading) => {
  return {
    type: SIGNUP_START,
    payload: loading,
  };
};
const signUpSuccess = (data) => {
  return {
    type: SIGNUP_SUCCESS,
    payload: data,
  };
};
const signUpError = (error) => {
  return {
    type: SIGNUP_ERROR,
    payload: error,
  };
};
export const signup = (formData) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(signUpStart(true));
    _signup(formData)
      .then(async (res) => {
        await dispatch(signUpSuccess(res));
        resolve(res);
      })
      .catch((err) => {
        const parsedError = errorParser.parseError(err);
        dispatch(signUpError(parsedError));
        reject(err);
      });
  });
};
